import { Button } from '@workingclock/ui';
import { useTranslation } from 'react-i18next';

import { useCookieConsent } from '../../contexts/cookie-consent-context';

/**
 * Opt-in, dismissible, TTDSG/GDPR-appropriate: nothing beyond essential
 * cookies is treated as allowed until a choice is made, "Reject
 * non-essential" is the same size and position as "Accept all" (not a
 * buried link), and "Manage preferences" opens the granular dialog.
 *
 * Renders nothing until the provider has read the stored decision, which
 * keeps it out of the SSG HTML and out of the first client render — see the
 * hydration note in contexts/cookie-consent-context.tsx.
 */
export function CookieConsentBanner() {
  const { t } = useTranslation('marketing');
  const { consent, hasReadStoredConsent, acceptAll, rejectAll, openPreferences } = useCookieConsent();

  if (!hasReadStoredConsent || consent) return null;

  return (
    <div
      role="region"
      aria-label={t('cookieConsent.banner.ariaLabel')}
      className="fixed inset-x-0 bottom-0 z-50 border-t border-border bg-bg px-4 py-4 md:px-6"
    >
      <div className="mx-auto flex max-w-6xl flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <p className="text-body text-ink md:max-w-2xl">
          {t('cookieConsent.banner.body')}{' '}
          <button
            type="button"
            onClick={openPreferences}
            className="font-medium text-gold underline-offset-4 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-bg"
          >
            {t('cookieConsent.banner.managePreferences')}
          </button>
          .
        </p>
        <div className="flex shrink-0 flex-col gap-2 sm:flex-row">
          <Button variant="secondary" onClick={rejectAll}>
            {t('cookieConsent.banner.reject')}
          </Button>
          <Button variant="primary" onClick={acceptAll}>
            {t('cookieConsent.banner.acceptAll')}
          </Button>
        </div>
      </div>
    </div>
  );
}
